'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'hat-wizard';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6e8';
var svgPathData = ['M16 456c0 22.1 17.9 40 40 40l400 0c22.1 0 40-17.9 40-40s-17.9-40-40-40L56 416c-22.1 0-40 17.9-40 40zm70.8-88L216 368l0-40-40 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l40 0 0-40c0-4.4 3.6-8 8-8s8 3.6 8 8l0 40 40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0 0 40 193.2 0L357 214.6c-3.3-7.4-5-15.4-5-23.5c0-6.5 1.1-13 3.2-19.1c17.5-50 35-100 52.5-150c.2-.5 .3-1 .3-1.5l0-1.5c0-1.6-1.3-3-3-3c-.5 0-1 .1-1.5 .4l-165 94.3c-32.5 18.6-58.3 47.1-73.5 81.3L86.8 368zM232 176c0-4.4 3.6-8 8-8l24 0 0-24c0-4.4 3.6-8 8-8s8 3.6 8 8l0 24 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-24 0 0 24c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-24-24 0c-4.4 0-8-3.6-8-8z', 'M442.7 368L371.6 208.1c-2.4-5.4-3.6-11.1-3.6-17c0-4.7 .8-9.4 2.4-13.8l52.5-150c.8-2.2 1.2-4.5 1.2-6.8l0-1.5c0-10.5-8.5-19-19-19c-3.3 0-6.5 .9-9.4 2.5l-165 94.3c-35.5 20.3-63.6 51.4-80.2 88.7L69.3 368l17.5 0 78.2-176c15.2-34.2 41-62.7 73.5-81.3l165-94.3c.4-.3 1-.4 1.5-.4c1.6 0 3 1.3 3 3l0 1.5c0 .5-.1 1-.3 1.5l15.1 5.3L407.7 22 355.2 172c-2.2 6.1-3.2 12.6-3.2 19.1c0 8.1 1.7 16.1 5 23.5L425.2 368l17.5 0zM456 416c22.1 0 40 17.9 40 40s-17.9 40-40 40L56 496c-22.1 0-40-17.9-40-40s17.9-40 40-40l400 0zM56 400c-30.9 0-56 25.1-56 56s25.1 56 56 56l400 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L56 400zM280 144c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-24zM232 272c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 40-40 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l40 0 0 40 16 0 0-40 40 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-40 0 0-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHatWizard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;